import { Box, Breadcrumbs, Dialog, DialogActions, DialogTitle, FormControl, FormHelperText, IconButton, InputLabel, Link, MenuItem, Select, styled, Tab, Tabs, Typography } from "@mui/material";
import RefreshButton from "../../components/global/RefreshButton";
import PrimaryButton from "../../components/global/PrimaryButton";
import DynamicIcon from "../../components/global/DynamicIcon";
import { useNavigate } from "react-router";
import ButtonBack from "../../components/global/ButtonBack";
import { useContext, useEffect, useState } from "react";
import FormContainer from "../../components/global/InputContainer";
import Input from "../../components/global/Input";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CentroCustoMultipleSelect from "../../components/comercial/CentroCustoMultipleSelect";
import CentroCustoSelect from "../../components/comercial/CentroCustoSelect";
import CargoSelectNew from "../../components/rh/CargoSelectNew";
import MotivoAfastamentoSelect from "../../components/rh/MotivoAfastamentoSelect";
import MotivoDemissaoSelect from "../../components/rh/MotivoDemissaoSelect";
import { useFuncionariosStore } from "../../stores/rh/funcionarios";
import { rhAPI } from "../../api";
import LoadingPage from "../../components/global/LoadingPage";
import AlertErro from "../../components/global/AlertErro";
import { Funcionario } from "../../types/rh/funcionario";
import dayjs from "dayjs";
import { InputValidation } from "../../types/global/inputErro";
import BottomBar from "../../components/global/BottomBar";
import DeleteDialog from "../../components/global/DeleteDialog";
import { AppContext } from "../../common/contexts/app_context/app_context";
import { CargoCadastroDialog } from "../../features/rh/presentation/dialogs/cargo_cadastro_dialog";



function FuncionarioRegister() {
  const navigate = useNavigate()

  const { setFuncionarios, filters } = useFuncionariosStore()
  const { setNoticeOpen, setMessageNotice } = useContext(AppContext)
  const [funcionario, setFuncionario] = useState<Funcionario>(new Funcionario())
  const [funcionarioBackup, setFuncionarioBackup] = useState<Funcionario>(new Funcionario())
  const { selectedFuncionarioId } = useFuncionariosStore()
  const [loadingPage, setLoadingPage] = useState(false)
  const [erroLoadPage, setErroLoadPage] = useState(true)
  const [messageErroLoadPage, setMessageErroLoadPage] = useState("")
  const [erroSave, setErroSave] = useState(false)
  const [messageErroSave, setMessageErroSave] = useState("")
  const [valueTab, setValueTab] = useState(1)
  const [dialogDeleteOpen, setDialogDeleteOpen] = useState(false)
  const [openNewCargoDialog, setOpenNewCargoDialog] = useState(false);

  const [nome, setNome] = useState(new InputValidation("O campo de nome é obrigatório."))
  const [admissao, setAdmissao] = useState(new InputValidation("O campo de data de admissão é obrigatório."))
  const [sexo, setSexo] = useState(new InputValidation("O campo de sexo é obrigatório."))
  const [centroCusto, setCentroCusto] = useState(new InputValidation("O campo de centro de custo é obrigatório."))
  const [cargo, setCargo] = useState(new InputValidation("O campo de cargo é obrigatório."))
  const [afastamento, setAfastamento] = useState(new InputValidation("O campo de motivo do afastamento é obrigatório."))
  const [demissao, setDemissao] = useState(new InputValidation("O campo de motivo da Demissão é obrigatório."))

  useEffect(() => {
    loadPage()
  }, [])

  const loadPage = async () => {
    setErroLoadPage(false)
    setLoadingPage(true)
    if (selectedFuncionarioId != 0) {
      const result = await rhAPI.getFuncionarioById(selectedFuncionarioId)
      if (result.statusCode == 200 && result.data) {
        setFuncionario(result.data)
        setFuncionarioBackup(result.data)
      }
      else {
        setErroLoadPage(true)
        setMessageErroLoadPage(result.error?.Message ?? "Ocorreu um erro inesperado.")
      }
    }
    else {
      setFuncionario(new Funcionario())
      setFuncionarioBackup(new Funcionario())
    }

    setLoadingPage(false)
  }

  const validateInputs = () => {
    if (!funcionario.nome) {
      setNome((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }

    if (!funcionario.sexo) {
      setSexo((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }

    if (!funcionario.dataadmissao) {
      setAdmissao((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }

    if (!funcionario.idCargo || funcionario.idCargo == 0) {
      setCargo((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }

    if (!funcionario.idCentroCusto || funcionario.idCentroCusto == 0) {
      setCentroCusto((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }

    if (funcionario.datademissao && !funcionario.idMotivoDemissao) {
      setDemissao((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }

    if (funcionario.dataafastamento && !funcionario.idMotivoAfastamento) {
      setAfastamento((item) => ({
        ...item,
        erro: true
      }))
      setMessageNotice("Preencha todos os campos obrigatórios.")
      setNoticeOpen(true)
      return false
    }

    return true
  }

  const handleDelete = async () => {
    if (selectedFuncionarioId != 0) {
      setLoadingPage(true)
      var result = await rhAPI.deleteFuncionario(selectedFuncionarioId)
      if (result.statusCode == 200) {
        setFuncionarios(filters)
        navigate("/Funcionarios_lista")
        setMessageNotice("Funcionário excluído com sucesso!")
        setNoticeOpen(true)
      }
      else {
        setDialogDeleteOpen(false)
        setErroSave(true)
        setMessageErroSave(result.error?.Message ?? "Ocorreu um erro inesperado.")
        setLoadingPage(false)
        setMessageNotice("Ocorreu algum erro ao tentar deletar.")
        setNoticeOpen(true)
      }
    }
  }

  const handleSave = async () => {
    if (validateInputs()) {
      setLoadingPage(true)
      if (selectedFuncionarioId != 0) {
        var result = await rhAPI.updateFuncionario(funcionario)
        if (result.statusCode == 200) {
          setFuncionarios(filters)
          navigate("/Funcionarios_lista")
          setMessageNotice("Alterações realizadas com sucesso!")
          setNoticeOpen(true)
        }
        else {
          setErroSave(true)
          setMessageErroSave(result.error?.Message ?? "Ocorreu um erro inesperado.")
          setMessageNotice("Ocorreu algum erro ao tentar salvar.")
          setNoticeOpen(true)
        }
      }
      else {
        var result = await rhAPI.createFuncionario(funcionario)
        if (result.statusCode == 200) {
          setFuncionarios(filters)
          navigate("/Funcionarios_lista")
          setMessageNotice("Alterações realizadas com sucesso!")
          setNoticeOpen(true)
        }
        else {
          setErroSave(true)
          setMessageErroSave(result.error?.Message ?? "Ocorreu um erro inesperado.")
          setLoadingPage(false)
          setMessageNotice("Ocorreu algum erro ao tentar salvar.")
          setNoticeOpen(true)
        }
      }
    }
  }

  return (
    <>
      <div className="flex w-full gap-6 flex-col pb-[62px] md:px-10 md:pt-10 p-4">
        <div className=" flex gap-4 items-center">
          <IconButton
            onClick={() => {
              navigate("/Funcionarios_lista")
            }} >
            <DynamicIcon
              nameIcon="ArrowBackRounded"
              size={35}
              className="text-primary-green" />
          </IconButton>
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit" >
              RH
            </Link>
            <Link
              underline="hover"
              color="inherit"
              onClick={() => {
                navigate("/Funcionarios_lista")
              }}
            >
              Funcionários
            </Link>
            <Typography className="text-primary-green">{selectedFuncionarioId != 0 ? "Editar" : "Novo"} funcionário</Typography>
          </Breadcrumbs>
        </div>
        {
          (loadingPage == false && erroLoadPage == false) &&
          <>
            <div className="div flex flex-col md:flex-row justify-between items-start gap-6">
              <div className="flex gap-2 flex-col items-start">
                <h1 className="text-3xl font-medium text-black dark:text-white">{selectedFuncionarioId == 0 ? "Novo funcionário" : funcionarioBackup.nome}</h1>
                {
                  selectedFuncionarioId != 0 &&
                  <div className="flex items-center gap-2">
                    <div
                      onClick={() => setDialogDeleteOpen(true)}
                      className="flex items-center gap-1 text-red-500 cursor-pointer dark:hover:bg-border-dark-gray hover:bg-hover-light-gray rounded-[4px] p-2">
                      <DynamicIcon nameIcon="DeleteForeverRounded" size={25} />
                      <h1 className="text-sm font-medium">Excluir funcionário</h1>
                    </div>
                  </div>
                }
              </div>
            </div>
            {
              erroSave == true &&
              <div className="w-full">
                <AlertErro messageErro={messageErroSave} onTryAgain={async () => await handleSave()} onClose={() => setErroSave(false)} />
              </div>
            }
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { background: '#009C4E' } }}
                value={valueTab}
                onChange={(event: React.SyntheticEvent, newValue: number) => {
                  setValueTab(newValue);
                }}>
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Informações Gerais" value={1} />
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Documentos/Comprovantes" value={2} />
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Treinamentos" value={3} />
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Controle de Patrimônio " value={4} />
                <Tab sx={{
                  textTransform: "none",
                  '&.Mui-selected': {
                    color: '#009C4E',
                  },
                }} label="Controle de Patrimônio " value={5} />
              </Tabs>
            </Box>
            {
              valueTab == 1 &&
              <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                <FormContainer title="Informações básicas">
                  <>
                    <Input
                      variant="outlined"
                      label="Nome"
                      required
                      error={nome.erro}
                      helperText={nome.messageErro}
                      value={funcionario.nome}
                      onChange={(x) => {
                        setNome((item) => ({
                          ...item,
                          erro: false
                        }))
                        setFuncionario((func) => ({
                          ...func,
                          nome: x.target.value,
                        }))
                      }} />
                    <DatePicker
                      slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      label="Data de nascimento"
                      defaultValue={null}
                      value={funcionario.datanascimento ? dayjs(funcionario.datanascimento) : null}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          datanascimento: x?.isValid() ? x.toISOString() : null,
                        }))
                      }}
                    />
                    <FormControl size="small" fullWidth>
                      <InputLabel id="sexo-funcionario" required error={sexo.erro}>Sexo</InputLabel>
                      <Select
                        labelId="sexo-funcionario"
                        label="Sexo"
                        required
                        error={sexo.erro}
                        value={funcionario.sexo}
                        onOpen={() => {
                          setSexo((item) => ({
                            ...item,
                            erro: false
                          }))
                        }}
                        onChange={(x) => {
                          setFuncionario((func) => ({
                            ...func,
                            sexo: x.target.value,
                          }))
                        }}
                      >
                        <MenuItem value={""}>Selecionar</MenuItem>
                        <MenuItem value={"F"}>Feminino</MenuItem>
                        <MenuItem value={"M"}>Masculino</MenuItem>
                      </Select>
                      {
                        sexo.erro == true &&
                        <FormHelperText error>{sexo.messageErro}</FormHelperText>
                      }
                    </FormControl>
                    <DatePicker
                      slotProps={{ textField: { size: 'small', fullWidth: true, required: true, error: admissao.erro, helperText: admissao.messageErro } }}
                      label="Data de admissão"
                      defaultValue={null}
                      value={funcionario.dataadmissao ? dayjs(funcionario.dataadmissao) : null}
                      onOpen={() => {
                        setAdmissao((item) => ({
                          ...item,
                          erro: false
                        }))
                      }}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          dataadmissao: x?.isValid() ? x.toISOString() : null,
                        }))
                      }}
                    />
                    <CargoSelectNew
                      required
                      erro={cargo.erro}
                      messageErro={cargo.messageErro}
                      value={funcionario.idCargo}
                      onOpen={() => {
                        setCargo((item) => ({
                          ...item,
                          erro: false
                        }))
                      }}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          idCargo: x,
                        }))
                      }}
                      onNewCargo={() => {
                        setOpenNewCargoDialog(true);
                      }}
                    />
                    {/*
                    <CargoSelect
                      required
                      erro={cargo.erro}
                      messageErro={cargo.messageErro}
                      value={funcionario.idCargo}
                      onOpen={() => {
                        setCargo((item) => ({
                          ...item,
                          erro: false
                        }))
                      }}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          idCargo: x,
                        }))
                      }}
                    />
                    */}
                    <FormControl size="small" fullWidth>
                      <InputLabel id="regime-funcionario">Regime de Contratação</InputLabel>
                      <Select
                        labelId="regime-funcionario"
                        label="Regime de Contratação"
                        value={funcionario.regimeContratacao}
                        onChange={(x) => {
                          setFuncionario((func) => ({
                            ...func,
                            regimeContratacao: x.target.value,
                          }))
                        }}
                      >
                        <MenuItem value={''}>Selecionar</MenuItem>
                        <MenuItem value={"C"}>CLT</MenuItem>
                        <MenuItem value={"E"}>Estagiário</MenuItem>
                        <MenuItem value={"P"}>PJ</MenuItem>
                        <MenuItem value={"D"}>Diarista</MenuItem>
                        <MenuItem value={"S"}>Sócio</MenuItem>
                        <MenuItem value={"J"}>Jovem Aprendiz</MenuItem>
                      </Select>
                    </FormControl>
                  </>
                </FormContainer>
                <FormContainer title="Centro de custo">
                  <CentroCustoSelect
                    required
                    erro={centroCusto.erro}
                    messageErro={centroCusto.messageErro}
                    value={funcionario.idCentroCusto}
                    onChange={(x) => {
                      setFuncionario((func) => ({
                        ...func,
                        idCentroCusto: x,
                      }))
                    }}
                  />
                </FormContainer>
                <FormContainer title="Informações adicionais">
                  <>
                    <Input
                      variant="outlined"
                      label="Setor"
                      value={funcionario.setor}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          setor: x.target.value,
                        }))
                      }} />
                    <Input
                      variant="outlined"
                      label="Filial"
                      value={funcionario.filial}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          filial: x.target.value,
                        }))
                      }} />
                  </>
                </FormContainer>
                <FormContainer title="Afastamento e demissão" border={false}>
                  <>
                    <MotivoDemissaoSelect
                      onOpen={() => {
                        setDemissao((item) => ({
                          ...item,
                          erro: false
                        }))
                      }}
                      value={funcionario.idMotivoDemissao}
                      erro={demissao.erro}
                      messageErro={demissao.messageErro}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          idMotivoDemissao: x,
                        }))
                      }}
                    />
                    <DatePicker
                      slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      label="Data da demissão"
                      defaultValue={null}
                      value={funcionario.datademissao ? dayjs(funcionario.datademissao) : null}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          datademissao: x?.isValid() ? x.toISOString() : null,
                        }))
                      }}
                    />
                    <MotivoAfastamentoSelect
                      onOpen={() => {
                        setAfastamento((item) => ({
                          ...item,
                          erro: false
                        }))
                      }}
                      erro={afastamento.erro}
                      messageErro={afastamento.messageErro}
                      value={funcionario.idMotivoAfastamento}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          idMotivoAfastamento: x,
                        }))
                      }}
                    />
                    <DatePicker
                      slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      label="Data do afastamento"
                      defaultValue={null}
                      value={funcionario.dataafastamento ? dayjs(funcionario.dataafastamento) : null}
                      onChange={(x) => {
                        setFuncionario((func) => ({
                          ...func,
                          dataafastamento: x?.isValid() ? x.toISOString() : null,
                        }))
                      }}
                    />
                  </>
                </FormContainer>
              </div>
            }
          </>
        }
        {
          (erroLoadPage == true && loadingPage == false) &&
          <AlertErro messageErro={messageErroLoadPage} onTryAgain={async () => await loadPage()} />
        }
        {
          loadingPage == true &&
          <LoadingPage />
        }
      </div>
      {
        (erroLoadPage == false) &&
        <BottomBar>
          <div className="w-full h-full items-center justify-end flex p-4 gap-4">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1 className="text-sm text-black dark:text-white" onClick={() => navigate("/Funcionarios_lista")}>Cancelar</h1>
            </div>
            <div className="w-[180px]">
              <PrimaryButton startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="primary-green" />} onClick={handleSave}>Salvar alterações</PrimaryButton>
            </div>
          </div>
        </BottomBar>
      }
      <DeleteDialog
        open={dialogDeleteOpen}
        onClose={() => setDialogDeleteOpen(false)}
        title={`Você realmente deseja excluir o(a) funcionário(a) ${funcionarioBackup.nome}?`}
        onDelete={handleDelete}
      />
      <CargoCadastroDialog
        openDialog={openNewCargoDialog}
        onClose={() => setOpenNewCargoDialog(false)}
        onSave={() => { }} />
    </>
  );
}

export default FuncionarioRegister;